import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import EtiquetaPage from './etiqueta.page';
import { connect } from 'react-redux';
import * as actions from '../../material.action';
import * as commonActions from '@common/common.action';
import { acessoPermitido } from '../../../../../../acessos.seguranca';
import WebapiCommon from '@common/util/webapi.common';
import moment from 'moment';
import Preview from '@componentes/PreviewURL';
import CommonFunctions from '@common/util/functions.common';

class EtiquetaContainer extends Component {
  constructor () {
    super();
    this.state = {
      selecionados: [],
      all: false,
      showModal: false,
      show: false,
      url: ''
    };
  }

  componentDidMount () {
    this.selecionarTodosOsFrascos(this.props.detalhes.imprimirEtiquetaDeControleDeMaterial)
  }

  onClickAll () {
    if (!this.state.all) {
      this.selecionarTodosOsFrascos(true);
    } else {
      this.setState({
        all: false,
        selecionados: []
      });
    }
  }

  imprimirEtiquetas () {
    var etiquetas = [];
    var frascosGravados = this.props.frascosGravados;

    this.state.selecionados.forEach(id => {
      const indice = frascosGravados.findIndex(f => f.frascoId === id);
      const frasco = frascosGravados.slice(indice, indice + 1)[0];
      const dsFrasco = frasco !== undefined ? frasco.dsFrasco : '';
      const topografia = frasco !== undefined ? frasco.topografia : '';
      const modelo = indice >= 0 ? 'MATERIAL' : 'CONTROLE_MATERIAL';

      etiquetas.push({
        impressora: 'clawPDF',
        modelo: modelo,
        codigoBarra: this.props.detalhes.nrExame,
        numeroExame: `${this.props.detalhes.nrExame} ${dsFrasco}`,
        numeroExameExterno: this.props.detalhes.nrExameExterno ? this.props.detalhes.nrExameExterno : '',
        nomePaciente: this.props.detalhes.paciente,
        topografia: topografia,
        nascimentoPaciente: this.props.detalhes.dataNascimento,
        numeroAtendimento: this.props.detalhes.nrAtendimento,
        numeroPedido: this.props.detalhes.nrPedido,
        recebidoEm: this.props.detalhes.dataEntradaMaterial,
        prontuario: this.props.detalhes.prontuario,
        entregarEm: this.props.detalhes.dataEntregaPrevista,
        numeroFrasco: frasco !== undefined ? frasco.nrFrasco : ''
      });
    });

    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.imprimirEtiquetaAreaTecnica(etiquetas, 'material')
      .then(data => {
        this.props.actions.imprimiEtiquetaAgora(false);
        this.props.commonActions.showFadeCarregando(false);
        var url = CommonFunctions.getPdfBlob(data.pdf);
        this.setState({ url: url });
        this.setShow(!this.state.show);
      })
      .catch(err => console.log(err));
  }

  selecionarTodosOsFrascos (incluirEtiquetaDeControle) {
    let _selecionados = [];
    let etiquetaDeControle = 0;

    if (incluirEtiquetaDeControle) {
      _selecionados.push(etiquetaDeControle);
    }

    for (let i = 0; i < this.props.frascosGravados.length; i++) {
      const frasco = this.props.frascosGravados[i];
      _selecionados.push(frasco.frascoId);
    }

    this.setState({
      all: incluirEtiquetaDeControle ? true : false,
      selecionados: _selecionados
    });
  }

  onClick (id) {
    const index = this.state.selecionados.indexOf(id);
    let _selecionados = [...this.state.selecionados];

    if (index === -1) {
      _selecionados.push(id);
    } else {
      _selecionados.splice(index, 1);
    }

    this.setState({
      selecionados: _selecionados
    });
  }

  setShow (show) {
    this.setState({ show });
    if (!show && this.props.toggle) {
      this.props.toggle();
    }
  }

  render () {
    return (
      <div>
        <Preview
          show={this.state.show}
          setShow={this.setShow.bind(this)}
          url={this.state.url}
        />
        <EtiquetaPage
          usuario={this.props.usuario}
          frascoscriados={this.props.frascosGravados}
          onClick={this.onClick.bind(this)}
          onClickAll={this.onClickAll.bind(this)}
          selecionados={this.state.selecionados}
          all={this.state.all}
          acessoPermitido={acessoPermitido}
          altura={this.props.altura}
          imprimirEtiquetas={this.imprimirEtiquetas.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    frascosGravados: state.commonReducer.frascosGravados,
    imprimiEtiquetaAgora: state.recebimentoMaterial.imprimiEtiquetaAgora,
    imprimiEtiquetaControle: state.recebimentoMaterial.imprimiEtiquetaControle
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EtiquetaContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/etiqueta/etiqueta.container.js